import React from 'react';
import { array, bool, func, object } from 'prop-types';

import AgentStatus from '../../components/AgentStatus';
import ErpAgentsTableRowMenu from './ErpAgentsTableRowMenu';

import classes from './ErpAgentsTable.module.css';
import MaterialTable from 'material-table';

const ErpAgentsTable = ({
    agents,
    companyInfo,
    isFullHubAllowed,
    onSort,
    ...props
}) => {
    const nameSorter = (a, b) => {
        const valueA = a.name.toUpperCase();
        const valueB = b.name.toUpperCase();
        if (valueA < valueB) {
            return -1;
        }
        if (valueA > valueB) {
            return 1;
        }
        return 0;
    };

    const renderMenu = rowData => {
        return (
            <ErpAgentsTableRowMenu
                agent={rowData}
                companyInfo={companyInfo}
                hidden={!isFullHubAllowed}
                onDeleteModal={props.onDeleteModal}
                onRenameAgentModal={props.onRenameAgentModal}
                onResetConfirmationModal={props.onResetConfirmationModal}
                onRotateCredentialsModal={props.onRotateCredentialsModal}
            />
        );
    };

    const renderNameCell = rowData => {
        return (
            <React.Fragment>
                <AgentStatus agent={rowData} />
                <span className={classes.rowName}>{rowData.name}</span>
            </React.Fragment>
        );
    };


    return (
        <div className={classes.AgentsTable}>
            <MaterialTable
                options={{
                    paging:    false,
                    showTitle: false,
                    search:    false,
                    selection: false,
                    sorting:   true,
                    toolbar:   false
                }}
                columns={[
                    {
                        title:       'Name',
                        render:      rowData => renderNameCell(rowData),
                        customSort:  nameSorter,
                        defaultSort: 'asc'
                    },
                    {
                        title: 'FSM Drivers',
                        field: 'agentType'
                    },
                    {
                        title: 'Serial Number',
                        field: 'agentSerial'
                    },
                    {
                        title: 'Software Version 111111',
                        field: 'softwareVersion'
                    },
                    {
                        title:  '',
                        render: rowData => renderMenu(rowData)
                    }
                ]}
                data={agents}
            />
        </div>
    );
};

ErpAgentsTable.defaultProps = {
    isFullHubAllowed: true,
    onSort:           () => {}
};

ErpAgentsTable.propTypes = {
    agents:                   array.isRequired,
    companyInfo:              object,
    isFullHubAllowed:         bool,
    onDeleteModal:            func,
    onRenameAgentModal:       func,
    onResetConfirmationModal: func,
    onSort:                   func
};

export default ErpAgentsTable;
